<template>
  <!-- <a-upload
    :action="domainUri"
    :disabled="!!$attrs.disabled"
    :data="{
      customerShopId: $attrs.customerShopId,
    }"
    @reject="rejectHandle"
    :file-list="fileList"
    @change="handleChange"
  >
    <el-button type="primary" :disabled="$attrs.disabled">
      <i class="el-icon-upload"></i>
      上传EXCEL
    </el-button>
  </a-upload> -->

  <el-upload class="uploader" action="actionUrl" :before-upload="beforeUpload" :http-request="uploadToOSS"
    :file-list="fileList" :show-file-list="false">
    <el-button type="primary" :disabled="$attrs.disabled">
      <i class="el-icon-upload"></i>
      上传EXCEL
    </el-button>
  </el-upload>
</template>

<script>
import { baseURL } from "@/const/env";
import axios from "axios";
import store from "@/store";
import "ant-design-vue/lib/upload/style/css";
import "ant-design-vue/lib/tooltip/style/css";
import { Tooltip } from "ant-design-vue";
import { Upload } from "ant-design-vue";
import { uploadExccel, createDeliveryTaskOperation } from "@/apis/outStock";
export default {
  name: "FBAExclUpload",
  components: {
    [Tooltip.name]: Tooltip,
    [Upload.name]: Upload,
  },
  data() {
    return {
      fileList: [],
      domain: {
        development: "http://192.168.201.65", // 开发
        production: "http://www.wms_sniff.com", // 生产
        test: "http://116.62.179.196", // 测试
      },
    };
  },
  props: {
    //
    record: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    domainUri: function () {
      const baseUrl = process.env.NODE_ENV;
      console.log(baseUrl);
      // return this.domain[baseUrl] + '' // auto
      return (
        "http://192.168.201.65" + "/amazonApi/inbound/upload/carton/size/info"
      ); // test
    },
  },
  methods: {
    // 上传 excl
    handleChange(info) {
      this.fileList = [info.file];
      switch (info.file.status) {
        case "done":
          this.$message.success(`${info.file.name} 上传成功`);
          this.$emit("refresh");
          break;
        case "error":
          this.$message.error(`${info.file.name} 上传失败`);
          break;
        case "removed":
          this.fileList = [];
          break;
      }
      console.log("info", info);
    },
    beforeUpload: function (file) {
      console.log("beforeUpload", file);
      return true;
    },
    rejectHandle: function (fileList) {
      this.$message.error("只支持 .xls 格式！");
    },

    uploadToOSS(res) {
      let uri = baseURL();
      let forms = new FormData();
      forms.append("customerShopId", this.$attrs.customerShopId || 53);
      forms.append("shipmentId", this.$attrs.shipmentId);
      forms.append("file", res.file);
      uploadExccel(forms).then(({ code, data }) => {
        if (code == 0) {
          this.$message.success("成功");
          this.$emit('refresh')
          createDeliveryTaskOperation({ nodeType: 12, bizNo: this.record.customerShopId, deliveryTaskCode: this.record.deliveryTaskCode })
        }
      });
      // axios({
      //   method: "post",
      //   url: uri + "/amazonApi/inbound/upload/carton/size/info",
      //   data: forms,
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     "X-AuthToken": store.getters.getToken
      //   },
      // }).then((res) => {
      //   console.log(res);
      // });
    },
  },
};
</script>

<style scoped></style>
